import { Events } from '|>/shared/events'
import { getXhr } from '|>/shared/utils/vhs'
import { on, register } from '|>/shared/vjs'
import { BaseComponent } from '../base'
import {
  createCslErrorState,
  handleCslHttpResponse,
  resetCslErrorState,
} from '../error-display/lib'

/** XHR error hook for players without ErrorDisplay; fires player.error(), no UI. */
@register
export class ErrorHandler extends BaseComponent {
  private cslErrorState = createCslErrorState()

  @on(Events.Media.Load, (src: Events.Media.Load) => src?.src)
  private sourceUrl?: string

  constructor(player, options) {
    super(player, options)
    this.responseHook = this.responseHook.bind(this)

    this.player_.on(['xhr-hooks-ready', 'loadstart'], () => {
      const xhr = getXhr(this.player_, 'Error handler')
      const onResponse = xhr?.onResponse
      const offResponse = xhr?.offResponse

      if (offResponse) offResponse(this.responseHook)
      if (onResponse) onResponse(this.responseHook)
    })

    this.player_.on(Events.Media.Load, () => {
      resetCslErrorState(this.cslErrorState)
    })
  }

  private responseHook(request, _error, response) {
    handleCslHttpResponse(
      this.player_,
      request,
      response,
      this.sourceUrl,
      this.cslErrorState
    )
  }
}
